// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Rp3qe","inner":"Form_inner__Q7tIb","range":"Form_range__380ai","name":"Form_name__3e0sq","actions":"Form_actions__3UzEJ"};